// extracted by mini-css-extract-plugin
module.exports = {"button":"SubscribeButton_button__3PEGi"};